import { Alert, AlertTitle } from "@mui/material";
import localisations from "../../localisation";

function FilePreCheckInValidPane() {
    const { title, description } = localisations.filePreCheckInvalidPane;

    return (
        <Alert severity="error">
            <AlertTitle>{title}</AlertTitle>
            {description}
        </Alert>
    );
}

export default FilePreCheckInValidPane;
